import { CmpProspectStatusEnum } from "../../../graphql/types";

type ProspectStatusSource = { status: CmpProspectStatusEnum; newLeadAtUtcMilli?: number | null };

// AE-6: a website membership inquiry is an Active prospect shown as "New Lead"
// until a staff member updates it. The Active filter includes New Leads.
export const isCmpProspectNewLead = (prospect: ProspectStatusSource) =>
  prospect.status === CmpProspectStatusEnum.Active && !!prospect.newLeadAtUtcMilli;

export const getCmpProspectStatusLabel = (prospect: ProspectStatusSource) =>
  prospect.status === CmpProspectStatusEnum.Converted
    ? "Converted to Member"
    : isCmpProspectNewLead(prospect)
      ? "New Lead"
      : "Active Prospect";
